export default __webpack_public_path__ + "static/media/gallery-wip-neck_10.fe21d95e.jpg";